import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { State } from "./State";
export var ValueState =
/*#__PURE__*/
function (_State) {
  _inherits(ValueState, _State);

  function ValueState() {
    _classCallCheck(this, ValueState);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueState).apply(this, arguments));
  }

  _createClass(ValueState, [{
    key: "toggle",
    value: function toggle(value) {
      if (this.is(value)) {
        return this.clear();
      } else {
        return this.setValue(value);
      }
    }
  }, {
    key: "is",
    value: function is(value) {
      return this.value === value;
    }
  }]);

  return ValueState;
}(State);